import { createRouter, createWebHistory } from 'vue-router'
import { selectRouteObject, cleanRoute } from 'app_alegra_commons/lazyLoadModule'

import MicroView from '@/vue/layouts/MicroView.vue'
import MicroViewVue2 from '@/vue/layouts/MicroViewVue2.vue'
import routeObjects from '@/config/Microfronts'
import useMicrofront from '@/vue/composables/useMicrofront'
import { store } from '@/vue/store'

const ENVIROMENT = String(process.env.VUE_APP_ENVIROMENT).toLowerCase()

function adjustRoutePathFromVue(route) {
  if (route.startsWith('/')) {
    route = route.slice(1)
  }
  if (route.endsWith('/*')) {
    route = route.replace('/*', '/:editMatch(.*)*')
  } else if (route.endsWith('/')) {
    route = route.slice(0, -1)
  }

  return route
}

const routes = [
  {
    path: '/:child*',
    name: 'app_principal_route',
    component: () => import(/* webpackChunkName: "index-route" */ '@/vue/layouts/BlankLayout.vue'),
  },
]

if (ENVIROMENT == 'testing' || ENVIROMENT == 'local') {
  routes.push({
    path: '/add/microfront',
    name: 'addNewMicrofront',
    component: () =>
      import(/* webpackChunkName: "add-micro" */ '@/vue/views/Microfront/AppAdd.vue'),
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const path = to.fullPath

  const {
    ['domain']: domain,
    ['name']: moduleName,
    ['path']: behavior,
    vueVersion,
    nameExportedRoutes,
    typeLoading,
  } = selectRouteObject({ route: path, routeObjects })

  store.TYPE_LOADING = typeLoading || 'SSkeletonTable'

  if (to.name == 'app_principal_route') {
    store.LOADING = true

    const { loadMicrofront, loadMicrofrontVue2 } = useMicrofront()

    try {
      if (!domain) next(from.fullPath)

      if (vueVersion == 2) {
        const mountApp = await loadMicrofrontVue2({
          domain,
          moduleName,
        })

        store.MICROINSTALLERS[moduleName] = mountApp

        router.addRoute({
          name: moduleName,
          path: `/${adjustRoutePathFromVue(behavior)}`,
          component: MicroViewVue2,
        })
      } else {
        const childrens = await loadMicrofront({
          domain,
          moduleName,
          nameExportedRoutes,
        })

        router.addRoute({
          name: moduleName,
          path: `/${cleanRoute(behavior)}`,
          component: MicroView,
          children: childrens,
        })
      }

      next(to.fullPath)
    } catch (error) {
      console.log('Error loading microfront', error)
      next(from.fullPath)
    }
  } else {
    if (to.name && to.name?.toString().split('-')[0] != moduleName) {
      router.removeRoute(to.name)
    }
  }

  window.dispatchEvent(new CustomEvent('microfrontend-route-change-vue3', { detail: { to, from } }))

  next()
})

export default router
